import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import
{
  startOfToday,
  endOfToday,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from "date-fns";
import { InputGroup, InputGroupText, Tooltip } from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import { Col, Container, Row, Card, CardHeader, CardBody } from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";
import CountUp from "react-countup";
import { keyframes } from "styled-components";
import { getAllActivities, getTakciEarn } from "../../../common/data";
import { lireRoleSession } from "../../../espace";

const Finances = ( props ) =>
{


  const [ roleSession, setRoleSession ] = useState( lireRoleSession )
  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      // console.log( 'obj localStorage:', obj )
      setRoleSession( obj.role )
    }
  }

  useEffect( () =>
  {
    getSessionData()
  }, [] )

  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    } );
    return dateObject;
  }

  const history = useHistory();
  const [ formData1, setFormData1 ] = useState( {} );
  const dispatch = useDispatch();
  const token = JSON.parse( localStorage.getItem( "authUser" ) )
    ? JSON.parse( localStorage.getItem( "authUser" ) ).accessToken
    : null;

  const [ reducerValue, forceUpdate ] = useReducer( ( x ) => x + 1, 0 );

  const [ isEdit, setIsEdit ] = useState( false );
  const [ driverSelected, setDriverSelected ] = useState( null );
  const [ isExportCSV, setIsExportCSV ] = useState( false );
  const [ parainage, setParainage ] = useState( [] );

  //delete Conatct
  const [ deleteModal, setDeleteModal ] = useState( false );
  const [ deleteModalMulti, setDeleteModalMulti ] = useState( false );
  const [ modal, setModal ] = useState( false );
  const [ modalMotif, setModalMotif ] = useState( false );

  const toggle = useCallback( () =>
  {
    if ( modal )
    {
      setModal( false );
      setParainage( null );
    } else
    {
      setModal( true );
    }
  }, [ modal ] );

  // Add Data
  const handleParainageClicks = () =>
  {
    setParainage( "" );
    setIsEdit( false );
    toggle();
  };

  const dateFormat = () =>
  {
    var d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    return d.getDate() + " " + months[ d.getMonth() ] + ", " + d.getFullYear();
  };

  const timeFormat = () =>
  {
    let d = new Date();
    let minutes =
      d.getMinutes().toString().length === 1
        ? "0" + d.getMinutes()
        : d.getMinutes();
    let hours = d.getHours().toString() % 12 || 12;
    hours = hours <= 9 ? ( hours = "0" + hours ) : hours;
    let ampm = d.getHours() >= 12 ? "PM" : "AM";
    return hours + ":" + minutes + ampm;
  };

  // Column
  const columns = useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
      //   Cell: ( cellProps ) =>
      //   {
      //     return <input type="checkbox" name="id" className="parainageCheckBox" value={ cellProps.row.original.id } />;
      //   },
      //   id: '#',
      // },

      {
        Header: props.t( "Chauffeurs" ),
        accessor: "last_name_conducteur",
        filterable: true,
        Cell: ( chauffeur ) => (
          <>
            { chauffeur.row.original.last_name_conducteur }
          </>
        ),
      },
      {
        Header: props.t( "" ),
        accessor: "first_name_conducteur",
        filterable: true,
        Cell: ( chauffeur ) => (
          <>
            { chauffeur.row.original.first_name_conducteur }
          </>
        ),
      },
      {
        Header: props.t( "Clients" ),
        accessor: "client_id",
        filterable: false,
        Cell: ( client ) => (
          <>
            { client.row.original.last_name_client }{ " " }
            { client.row.original.first_name_client }
          </>
        ),
      },
      {
        Header: props.t( "Service" ),
        accessor: "type",
        filterable: true,
      },
      {
        Header: props.t( "Distance" ),
        accessor: "distance_estimee",
        filterable: false,
        Cell: ( distance ) => (
          <>
            { distance.row.original.distance_effective }
            { " Km" }
          </>
        ),
      },

      {
        Header: props.t( "Coût effectif" ),
        accessor: "cout_effectif",
        filterable: false,
        Cell: ( cout ) => <>{ cout.row.original.cout_effectif || 0 }</>,
      },
      {
        Header: props.t( "Paiement" ),
        accessor: "mode_payement",
        filterable: true,
      },
      // {
      //   Header: props.t("Action"),
      //   Cell: (cellProps) => {
      //     const parainageData = cellProps.row.original;
      //     const parainageDataId = cellProps.row.original.id;
      //     const [info, setInfo] = useState([]);
      //     return (
      //       <ul className="list-inline hstack gap-2 mb-0">
      //         <li className="list-inline-item" title={props.t("Voir")}>
      //           <Link
      //             // to={`/parainageDetail/${parainageData.id}`}
      //             to={"#"}
      //             className="btn btn-sm btn-success d-inline-block"
      //             onClick={() => {
      //               const parainageData = cellProps.row.original;
      //             }}
      //           >
      //             <i className="ri-eye-fill align-bottom"></i>
      //           </Link>
      //         </li>
      //       </ul>
      //     );
      //   },
      // }
    ],
    [ props ]
    // [setInfo, handleParainageClick, toggle, props, handlerefuse, handleaccept]
  );

  const [ coursesList, setCoursesList ] = useState( [] );
  const [ portefeuilleTakci, setPortefeuilleTakci ] = useState( 0 );
  const [ activitiesList, setActivitiesList ] = useState( [] );
  const [ coursesRevenues, setCoursesRevenues ] = useState( {
    annee: 0,
    mois: 0,
    semaine: 0,
    today: 0,
    global: 0,
  } );

  const getRevenusByPeriod = ( dataActivities, datedebut, datefin ) =>
  {
    // console.log("datedebut: ", datedebut);
    // console.log("datefin: ", datefin);
    // console.log("dataActivities: ", dataActivities);
    try
    {
      const revenus = dataActivities
        .filter(
          ( course ) =>
            new Date( course.date ) >= new Date( datedebut ) &&
            new Date( course.date ) <= new Date( datefin )
        )
        .reduce(
          ( sum, course ) => sum + ( parseFloat( course.cout_effectif ) || 0 ),
          0
        ); // Somme des cout_effectif
      return revenus;
    } catch ( error )
    {
      console.error( "Erreur dans le calcul des revenus :", error );
      return 0;
    }
  };

  const fetchCourseList = async () =>
  {
    try
    {
      const dataActivities = await getAllActivities();
      const portefeuille_takci = await getTakciEarn();
      setPortefeuilleTakci( portefeuille_takci );
      // console.log("dataActivities: ", dataActivities);
      setActivitiesList( dataActivities );
      let datedebut, datefin;

      // case "aujourd'hui"
      datedebut = startOfToday();
      datefin = endOfToday();
      const revenus = dataActivities.reduce(
        ( sum, course ) => sum + ( parseFloat( course.cout_effectif ) || 0 ),
        0
      );
      const today = getRevenusByPeriod( dataActivities, datedebut, datefin );

      // case "semaine":
      datedebut = startOfWeek( new Date(), { weekStartsOn: 1 } ); // Assuming the week starts on Monday
      datefin = endOfWeek( new Date(), { weekStartsOn: 1 } );
      const week = getRevenusByPeriod( dataActivities, datedebut, datefin );

      // case "mois":
      datedebut = startOfMonth( new Date() );
      datefin = endOfMonth( new Date() );
      const month = getRevenusByPeriod( dataActivities, datedebut, datefin );

      // case "an":
      datedebut = startOfYear( new Date() );
      datefin = endOfYear( new Date() );

      const year = getRevenusByPeriod( dataActivities, datedebut, datefin );

      setCoursesRevenues( {
        annee: year,
        mois: month,
        semaine: week,
        today: today,
        global: revenus,
      } );

      // setCoursesList(
      //   course_list.data.data.filter(
      //     (course) => course.course_status === "Terminer"
      //   )
      //   // .sort((a, b) => new Date(b.date_cours) - new Date(a.date_cours))
      // );
      // console.log(course_list);
      // console.log("Course List: ", course_list.data.data);
    } catch ( err )
    {
      console.error( err );
    }
  };

  useEffect( () =>
  {
    fetchCourseList();
  }, [] );

  // Fonction pour calculer le coût estimé total par année, mois et semaine
  async function calculerCoutEstimeTotal ()
  {
    const now = new Date();
    const anneeEnCours = now.getFullYear().toString();
    const moisEnCours = ( now.getMonth() + 1 ).toString().padStart( 2, "0" );
    const semaineEnCours = getWeekNumber( now ).toString(); // Fonction pour obtenir le numéro de semaine
    // console.log("anneeEnCours: ", anneeEnCours);
    // console.log("moisEnCours: ", moisEnCours);
    // console.log("semaineEnCours: ", semaineEnCours);

    let coutEstimeTotalAnnee = 0;
    let coutEstimeTotalMois = 0;
    let coutEstimeTotalSemaine = 0;

    // Filtrer et calculer pour chaque course
    activitiesList.forEach( ( course ) =>
    {
      const coutEstime = course.cout_effectif
        ? parseFloat( course.cout_effectif )
        : 0; // Convertir en nombre

      const dateCourse = new Date( course.date );
      const anneeCourse = dateCourse.getFullYear().toString();
      const moisCourse = ( dateCourse.getMonth() + 1 )
        .toString()
        .padStart( 2, "0" );

      const semaineCourse = getWeekNumber( dateCourse ).toString(); // Fonction pour obtenir le numéro de semaine

      // Filtrer par année
      if ( anneeCourse === anneeEnCours )
      {
        coutEstimeTotalAnnee += coutEstime;
      }

      // Filtrer par mois
      if ( anneeCourse === anneeEnCours && moisCourse === moisEnCours )
      {
        coutEstimeTotalMois += coutEstime;
      }

      // Filtrer par semaine
      if ( anneeCourse === anneeEnCours && semaineCourse === semaineEnCours )
      {
        coutEstimeTotalSemaine += coutEstime;
      }
    } );

    // Retourner les totaux calculés
    return {
      annee: coutEstimeTotalAnnee,
      mois: coutEstimeTotalMois,
      semaine: coutEstimeTotalSemaine,
    };
  }

  // Fonction pour obtenir le numéro de semaine à partir d'une date
  function getWeekNumber ( date )
  {
    const startOfYear = new Date( date.getFullYear(), 0, 1 );
    const diff =
      date -
      startOfYear +
      ( startOfYear.getTimezoneOffset() - date.getTimezoneOffset() ) * 60 * 1000;
    const oneWeek = 60 * 60 * 24 * 7 * 1000;
    return Math.floor( diff / oneWeek ) + 1;
  }

  const [ revenueTotalData, setRevenueTotalData ] = useState( [] );

  useEffect( () =>
  {
    async function fetchRevenueTotals ()
    {
      setRevenueTotalData( [
        {
          id: 0,
          title: "Revenue Journalier",
          value: coursesRevenues.today,
          prefix: "XOF ",
          icon: "ri-line-chart-fill",
        },
        {
          id: 3,
          title: "Revenue Hebdomadaire",
          value: coursesRevenues.semaine,
          prefix: "XOF ",
          icon: "ri-line-chart-fill",
        },
        {
          id: 2,
          title: "Revenue Mensuel",
          value: coursesRevenues.mois,
          prefix: "XOF ",
          icon: "ri-line-chart-fill",
        },
        {
          id: 1,
          title: "Revenue Annuel",
          value: coursesRevenues.annee,
          prefix: "XOF ",
          icon: "ri-line-chart-fill",
        },
        {
          id: 7,
          title: "Revenue général",
          value: coursesRevenues.global,
          prefix: "XOF ",
          icon: "ri-line-chart-fill",
        },

        {
          id: 6,
          title: "Solde TAKCI",
          value: portefeuilleTakci,
          prefix: "XOF ",
          icon: "ri-line-chart-fill",
        },
      ] );
    }

    fetchRevenueTotals();
  }, [ coursesRevenues ] );
  // SideBar Parainage Deatail

  document.title = props.t( "Finances | Takci" );
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ props.t( "Finances" ) } pageTitle="Takci" />

          <Row>
            { revenueTotalData ? (
              revenueTotalData.map( ( item, key ) => (
                <Col key={ key } md={ 6 } lg={ 4 }>
                  <Card>
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <div className="avatar-sm flex-shrink-0">
                          <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                            <i className={ `align-middle ${ item.icon }` }></i>
                          </span>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                            { item.title }
                          </p>
                          <h4 className="mb-0">
                            <CountUp
                              start={ 0 }
                              end={ item.value }
                              decimals={ 0 }
                              separator="."
                              prefix={ item.prefix }
                              duration={ 3 }
                            />
                          </h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ) )
            ) : (
              <Col md={ 6 } lg={ 4 }>
                <Card className="text-center my-3">
                  {/* <Spinner size="sm" className=''
                            style={ { color: '#014c94' } }
                          /> */}
                  <Loader style={ { color: "#014c94" } } />
                  <h2>Chargement...</h2>
                </Card>
              </Col>
            ) }
          </Row>

          <Row>
            <Col lg={ 12 }>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      { activitiesList && activitiesList.length > 0 && (
                        <button
                          disabled={
                            !activitiesList && activitiesList.length < 0
                          }
                          type="button"
                          className="btn"
                          style={ { color: "#eac22f" } }
                          onClick={ () => setIsExportCSV( true ) }
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{ " " }
                          { props.t( "Export" ) }
                        </button>
                      ) }
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={ 12 }>
              <Card id="parainageList">
                <CardBody className="pt-0">
                  <div>
                    { activitiesList && activitiesList.length > 0 ? (
                      <>
                        <ExportCSVModal
                          show={ isExportCSV }
                          onCloseClick={ () => setIsExportCSV( false ) }
                          data={
                            activitiesList && activitiesList.length > 0
                              ? activitiesList
                              : []
                          }
                        />

                        <TableContainer
                          columns={ columns }
                          data={ activitiesList || [] }
                          isGlobalFilter={ true }
                          isAddUserList={ false }
                          customPageSize={ 8 }
                          className="custom-header-css"
                          divClass="table-responsive table-card mb-3"
                          tableClass="align-middle table-nowrap"
                          theadClass="table-light"
                          handleParainageClick={ handleParainageClicks }
                        />
                      </>
                    ) : (
                      <div className="text-center my-3">
                        {/* <Spinner size="sm" className=''
                            style={ { color: '#014c94' } }
                          /> */}
                        <Loader style={ { color: "#014c94" } } />
                        <h2>Chargement...</h2>
                      </div>
                    ) }
                  </div>

                  <ToastContainer closeButton={ false } />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Finances.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( Finances ) );
